import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { VOUCHER_TYPE_OPTIONS } from "@/constants/voucherType";
import BogoCreate from "./BogoCreate";
import BogoEdit from "./BogoEdit";

export const bogo = {
  create: BogoCreate,
  edit: BogoEdit,
  icon: CardGiftcardIcon,
  options: {
    label:
      VOUCHER_TYPE_OPTIONS.find((t) => t.value === "bogo")?.label ||
      "Buy one, Get one",
  },
};
